import React, { createContext, useState, useContext, useEffect } from 'react';
import translations from '../locales/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Vérifier si une langue est sauvegardée dans localStorage
    return localStorage.getItem('atc-language') || 'fr';
  });

  const [t, setT] = useState(translations[language] || translations.fr);

  useEffect(() => {
    // Mettre à jour les traductions quand la langue change
    setT(translations[language] || translations.fr);
    localStorage.setItem('atc-language', language);
    document.documentElement.lang = language === 'fr' ? 'fr' : 'en';
  }, [language]);

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, t, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};